import { FeatureFlagKeys } from "@sg-protect/federation-runtime";
import { useFeatureFlag } from "@sg-protect/federation-runtime/squide";
import { useParams } from "react-router";

export function useIsProjectTabsLayout(): boolean {
    const isPlanReleased = useFeatureFlag(FeatureFlagKeys.MigrationPlanReleased, false);
    const isActivityReleased = useFeatureFlag(FeatureFlagKeys.MigrationActivityReleased, false);
    const { projectId } = useParams();

    return (isPlanReleased || isActivityReleased) && Boolean(projectId);
}
